






















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { FormGroup } from '@/shared/forms/form-group'

@Component({
  inject: ['form'],
})
export default class UnifyFormToggle extends Vue {
  @Prop({
    type: String,
  })
  public readonly control!: string

  @Prop({
    type: [String],
  })
  public readonly value!: string

  public readonly form!: FormGroup<any>

  public get formControl() {
    return this.form.field(this.control)
  }

  public get invalid() {
    return this.formControl.$invalid
  }

  public get required() {
    return this.formControl.hasOwnProperty('required')
  }

  public update(event: InputEvent) {
    const target = event.target as HTMLInputElement

    this.$emit('input', target.value)
  }
}
